import type { App } from 'vue';
import { EntitlementsService, ENTITLEMENTS_SERVICE_KEY } from '@erebus/entitlements';
import { FeatureFlagsService, FEATURE_FLAGS_SERVICE_KEY } from '@erebus/feature-flags';
import { erebus } from './axios';
import { restoreCookieSession } from './session';

type RestoreDeps = Parameters<typeof restoreCookieSession>[0];

/**
 * Provides the flag and entitlement services, then, in cookie mode, restores
 * the session (PRX-1745). Called from main.ts before the router.
 *
 * The order matters. The feature-flags store `inject`s its service once, when
 * the store is first created, and the cookie restore is what first creates it
 * (it fetches the flags). Provided any later, the store is built with no
 * service, every fetch fails, and every flag reads false for the whole page.
 * They only need the `erebus` instance, so nothing stops them going first.
 *
 * Bearer mode fetches its flags later in main.ts, also after this.
 */
export async function bootSession(app: App, cookieAuth: boolean, deps: RestoreDeps): Promise<void> {
  // Feature flags (global) + Entitlements (per-client module access)
  app.provide(ENTITLEMENTS_SERVICE_KEY, new EntitlementsService(erebus));
  app.provide(FEATURE_FLAGS_SERVICE_KEY, new FeatureFlagsService(erebus));

  if (cookieAuth) {
    await restoreCookieSession(deps);
  }
}
